/*
		debug.js,
			Debugging helpers with explicit support for firebug.
 */

//#include <base.js>

var Debug = module.exports = {
	vformat: function(fmtstring, args) {
		var argptr = 0;
		var curpos = 0;
		var next;
		var buffer = "";

		while(true) {
			next = fmtstring.indexOf("%", curpos);
			if(next == -1) {
				buffer += fmtstring.substr(curpos);
				break;
			}
			buffer += fmtstring.substr(curpos, next - curpos);
			var arg = fmtstring.substr(next, 2);
			curpos = next + 2;
			if(arg == "%%")
				buffer += "%";
			else if(arg == "%s") {
				var val = args[argptr++];
				if(val == null)
					buffer += "null";
				else if(val == undefined)
					buffer += "undefined";
				else
					buffer += val.toString();
			}
		}

		return buffer;
	},

	format: function() {
		var args = $A(arguments);
		var fmtstring = args.shift();				// throw an exception if this isn't set

		return Debug.vformat(fmtstring, args);
	},

	log: function() {
	},

	info: function() {
	},

	warn: function() {
	},

	error: function() {
	},

	profile: function(title) {
	},

	profileEnd: function() {
	},

	trace: function() {
	}
}

if(window.console) {
	Debug.log = console.info;
	Debug.info = console.info;
	Debug.warn = console.warn;
	Debug.error = console.error;
	Debug.profile = console.profile;
	Debug.profileEnd = console.profileEnd;
	Debug.trace = console.trace;
}

